import { ROLES } from "@typings/entities/users/enums";
import type { ResourcePermissions } from "@typings/permissions";

export const permissions: ResourcePermissions = {
  releases: {
    create: [ROLES.ADMIN],
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    update: [ROLES.ADMIN],
  },

  individuals: {
    create: [ROLES.ADMIN, ROLES.LAPAS],
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    update: [ROLES.ADMIN, ROLES.LAPAS],
  },

  taxonomicGroups: {
    create: [ROLES.ADMIN],
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    update: [ROLES.ADMIN],
  },

  registers: {
    create: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    update: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
  },

  samples: {
    create: [ROLES.ADMIN, ROLES.LAPAS],
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    update: [ROLES.ADMIN, ROLES.LAPAS],
  },

  locations: {
    create: [ROLES.ADMIN, ROLES.LAPAS],
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    update: [ROLES.ADMIN, ROLES.LAPAS],
  },

  visits: {
    create: [ROLES.ADMIN, ROLES.LAPAS],
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    update: [ROLES.ADMIN, ROLES.LAPAS],
  },

  cameraTraps: {
    create: [ROLES.ADMIN, ROLES.LAPAS],
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    update: [ROLES.ADMIN, ROLES.LAPAS],
  },

  collars: {
    create: [ROLES.ADMIN, ROLES.LAPAS],
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
    update: [ROLES.ADMIN, ROLES.LAPAS],
  },

  users: {
    create: [ROLES.ADMIN],
    read: [ROLES.ADMIN],
    update: [ROLES.ADMIN],
    delete: [ROLES.ADMIN],
  },

  reports: {
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
  },

  notifications: {
    read: [ROLES.ADMIN, ROLES.SEFAC, ROLES.IBAMA, ROLES.LAPAS],
  },
};
